/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
export default {
  name: 'StarLabel',
  props: {
    width: {
      type: String,
      default: '9.6rem'
    },
    showRed: {
      type: Boolean,
      default: true
    }
  }
};